import { useDispatch, useSelector } from "react-redux";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";
import BizDevelopmentDashboard from "../../../components/BizDevelopment/Dashboard/DashboardDesktop/BizDevelopmentDashboard";
import { useEffect } from "react";
import { resetBizDevelopmentDashboardState } from "../../../features/bizDevelopmentDashboardSlice";

const BizDevelopmentDashboardScreen = () => {
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData);
  const hasBizDevelopmentDashboardPermission = CheckPermissions(
    userData?.data?.products?.paid_traffic,
    "performance_analysis",
    "view_Bizdev_dashboard",
  );

  // Reset the Biz Development Dashboard state when the component unmounts
  useEffect(() => {
    return () => {
      // Reset the Biz Development Dashboard state when the component unmounts
      dispatch(resetBizDevelopmentDashboardState());
    };
    //eslint-disable-next-line
  }, []);

  return (
    <>
      {hasBizDevelopmentDashboardPermission ? (
        <BizDevelopmentDashboard />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default BizDevelopmentDashboardScreen;
